import {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as Member from '../../store/ducks/member.duck'
import DashboardBox from '../../components/DashboardBox'
import DashboardSection from '../../components/Cards/DashboardSection'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import HistoryClaimsTable from '../../components/Tables/HistoryClaimsTable'
import {NavLink} from 'react-router-dom'

export default function ClaimsHistoryDashboard() {
  // Determine AETNA SSO Login
  const aetnasso = useSelector((state: any) => state.member.AETNA)
  const [requestAetnaSSO, setrequestAetnaSSO] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!aetnasso && !requestAetnaSSO) {
      dispatch(Member.actions.fetchAETNA())
      setrequestAetnaSSO(true)
    }
  }, [dispatch, aetnasso, requestAetnaSSO])

  const title = 'Claims history'

  return (
    <DashboardBox hasMobileFullWidth>
      <DashboardSection
        name={title}
        className='table_box_xl_device'
        // button={
        //   <NavLink to='/submit-claim'>
        //     <Button variant='contained' startIcon={<AddIcon />} disableElevation>
        //       New Claim
        //     </Button>
        //   </NavLink>
        // }
      >
        <div className='text-start flex flex-col items-start justify-start gap-2.5 mt-3 mb-3'>
          <p className='claim-text'>Your FSBP Claim uploads from the Member Portal are displayed below. Claims are stored in your account for three years from the date of upload.</p>
          <p className='claim-text'>
            Domestic claims are typically processed within 30 days of receipt, while foreign claims take about <span style={{fontWeight: 600, fontStyle: 'italic'}}>10 to 14 business days</span>.{' '}
          </p>
          <p className='claim-text'> If additional information is required, please upload it the same way you submitted your initial claim. </p>
          <p className='claim-text'>
            You can check the status of your claims by visiting the Aetna Member Secure Website through the
            <span style={{textDecoration: 'underline', textDecorationColor: 'blue', color: 'blue'}}>
              <a href={aetnasso && aetnasso} target='_blank' rel='noopener noreferrer'>
                {' Member Portal`s Single Sign On (SSO).'}
              </a>
            </span>
            or by accessing the website directly at <a href='https://www.aetna.com'>www.aetna.com</a>. If you haven`t registered for the Aetna Member Secure Website yet, we encourage you to do so.
          </p>
        </div>
        <HistoryClaimsTable />
      </DashboardSection>
      <div className='table_box_mobile w-full'>
        <DashboardSection
          name={title}
          // button={
          //   <NavLink to='/submit-claim'>
          //     <div role='button' className='circle_button_icon hover:brightness-90'>
          //       <AddIcon style={{color: 'white', fontSize: '26px'}} />
          //     </div>
          //   </NavLink>
          // }
        >
          <div className='w-full h-4'></div>
        </DashboardSection>
        <HistoryClaimsTable displayForMobile />
      </div>
    </DashboardBox>
  )
}
